import { defineStore } from 'pinia'
import type { CertificateData } from '@/api/certificate'

export const useCertificateStore = defineStore('certificate', {
  state: () => ({
    certificate: undefined,
  } as {
    certificate?: CertificateData;
  }),

  actions: {
    async validate(certificateNumber: string) {
      const { $api, $sentry } = useNuxtApp()

      try {
        const result = await $api.certificate.validate(certificateNumber)

        this.certificate = result
      } catch (error) {
        $sentry.captureException(error)
      }
    },
  },
})
